import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { ErrorBoundary } from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import { getRecentlyViewedSubAppKeysForHomePage } from '../../utils/recentlyViewedTemplatesUtils';
// @ts-expect-error Untyped import
import { useAnalyticsPermissions } from '../../utils/useAnalyticsPermissions';
// @ts-expect-error Untyped import
import { getHasAccessToSubApp } from '../../utils/reportingIAUtils';
// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
import DescriptiveReportCard from './DescriptiveReportCard';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoErrorComponent = () => null;
const RecentlyViewedTemplatesSection = ({
  suiteId
}) => {
  const recentlyViewedSubApps = getRecentlyViewedSubAppKeysForHomePage(suiteId);
  const analyticsPermissions = useAnalyticsPermissions();
  const accessibleRecentlyViewed = useMemo(() => {
    return recentlyViewedSubApps.filter(subAppKey => getHasAccessToSubApp(subAppKey, analyticsPermissions));
  }, [analyticsPermissions, recentlyViewedSubApps]);
  if (accessibleRecentlyViewed.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "700",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.collectionHomes.recentlyViewed"
      })
    }), /*#__PURE__*/_jsx(CardGrid, {
      gutterSize: 16,
      columnSize: 320,
      children: accessibleRecentlyViewed.map(subAppKey => /*#__PURE__*/_jsx(DescriptiveReportCard, {
        useCompact: true,
        subAppKey: subAppKey,
        trackingEvent: EVENTS.clickRecentReportsCard
      }, subAppKey))
    }, `${suiteId}-recently-viewed`)]
  });
};
const RecentlyViewedWithErrorBoundary = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  ErrorComponent: NoErrorComponent,
  children: /*#__PURE__*/_jsx(RecentlyViewedTemplatesSection, Object.assign({}, props))
});
export default RecentlyViewedWithErrorBoundary;